var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0C4.16563 0 4.5 0.334375 4.5 0.75V2H9.5V0.75C9.5 0.334375 9.83438 0 10.25 0C10.6656 0 11 0.334375 11 0.75V2H12C13.1031 2 14 2.89687 14 4V13C14 14.1031 13.1031 15 12 15H2C0.896875 15 0 14.1031 0 13V4C0 2.89687 0.896875 2 2 2H3V0.75C3 0.334375 3.33437 0 3.75 0ZM3.75 3.5H2C1.725 3.5 1.5 3.725 1.5 4V5.5H12.5V4C12.5 3.725 12.275 3.5 12 3.5H3.75ZM1.5 7V13C1.5 13.275 1.725 13.5 2 13.5H12C12.275 13.5 12.5 13.275 12.5 13V7H1.5Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservations);
export default __webpack_public_path__ + "static/media/reservations.d5fe2c261b88a947cfc431af58908ba9.svg";
export { ForwardRef as ReactComponent };